// NOTE: 献立の閲覧履歴。 `[1, 2, 3]` のようにIDが配列で保存される
export const SHOW_HISTORY_MENU_KEY = 'show_history_menu';

// NOTE: レシピの閲覧履歴。 `[1, 2, 3]` のようにIDが配列で保存される
export const SHOW_HISTORY_RECIPE_KEY = 'show_history_recipe';

// NOTE: レシピのお気に入り。 `[1, 2, 3]` のようにIDが配列で保存される
export const FAVORITE_RECIPE_KEY = 'favorite_recipes';
